
export const tableTheme = {
  "components": {
    "MUIDataTable": {
      "styleOverrides": {
        "root": {
          "height": "calc(100% - 40px)",
          "background": "#e6edec !important"
        },
        "paper": {
          "display": "flex",
          "flexDirection": "column"
        }
      }
    },
    "MuiTable": {
      "styleOverrides": {
        "root": {
          "background": "#CBF0F0"
        }
      }
    },
    "MuiTableCell": {
      "styleOverrides": {
        "root": {
          "paddingTop": "0px",
          "paddingBottom": "0px",
          "paddingLeft": "3px",
          "paddingRight": "3px",
          "minHeight": "11px",
          "fontSize": "12px"
        },
        "footer": {
          "padding": "0px 24px 0px 24px !important",
          "backgroundColor": "#e6edec !important"
        }
      }
    },
    "MuiToolbar": {
      "styleOverrides": {
        "root": {
          "minHeight": "auto !important",
          "maxHeight": "800px !important",
          "paddingBottom": "2px"
        }
      }
    },
    "MUIDataTableHeadCell": {
      "styleOverrides": {
        "root": {
          "backgroundColor": "#e6edec !important",
          "paddingTop": "3px",
          "paddingBottom": "0px",
          "paddingLeft": "3px",
          "paddingRight": "3px",
          "fontSize": "12px",
          "minWidth": "60px"
        },
        "data": {
          "fontSize": "12px",
          "minWidth": "60px",
          "textTransform": "none !important"
        }
      }
    },
    "MUIDataTableSelectCell": {
      "styleOverrides": {
        "checkboxRoot": {
          "height": "20px",
          "width": "20px",
          "padding": "0px"
        }
      }
    },
    "MUIDataTableToolbarSelect": {
      "styleOverrides": {
        "root": {
          "flex": 0
        }
      }
    }
  }
};

export const ExpType = {
  "EXP-B": "avant",
  "EXP-F": "après"
};

export const ExpTypeFilter = [{ "EXP-B": "avant" }, { "EXP-F": "après" }];

export const rowsPerPageOptions = [10, 20, 50, 100];

export const producerOptions = [
  { "YATEA": "Yatea" },
  { "LISTS": "List" },
  { "TSUIT": "TermSuite" },
  { "SKOS": "SKOS" },
  { "USERS": "Utilisateur" }
];

export const labels = {
  YateaImport: [
    "Veuillez charger les fichers XML, encodés en UTF-8, au format YaTeA",
    "http://taln09.blogspot.com/2009/03/description-lextracteur-de-termes-yatea.html",
    "pour importer des termes et leurs formes dans TyDI."
  ],
  TermSuiteImport: [
    "Veuillez charger les fichers TSV, encodés en UTF-8, au format TermSuite",
    "https://termsuite.github.io/documentation/terminology-tsv-output/",
    "pour importer des termes et leurs formes dans TyDI."
  ],
  ListePlateImport: <>
    Veuillez charger les fichers csv (séparateur virgule), encodés en UTF-8, contenant les colonnes class ou term (obligatoire), lemma, relevance, postag, lang, synonyms (synonymes séparés par des points-virgules) pour importer des termes et leurs formes dans TyDI.
    Si l'en-tête est class, une classe est crée par ligne du fichier. Si l'en-tête est term, aucune classe n'est crée, les synonymes sont des termes liés.
    <p>ATTENTION - De nouveaux termes sont créés dans tous les cas, même s''il existe des termes homonymes dans le projet.</p>
  </>,
  SkosImport: [
    "Veuillez charger les fichers RDF, encodés en UTF-8, au format SKOS",
    "https://www.w3.org/2004/02/skos/",
    "pour importer des classes sémantiques dans TyDI."
  ],
  documentsImport: "Veuillez charger les fichiers .txt, encodés en UTF-8, par document pour les importer dans TyDI. Il est possible de sélectionner plusieurs fichiers en même temps."
};

export const relationsName = {
  "VARIATE": "Variation",
  "ACRONYM": "Acronyme",
  "TRANSLT": "Traduction",
  "SYNONYM": "Synonyme",
  "QUA-SYN": "Quasi-Synonyme",
}

export const TermDocsTableTheme = {
  components: {
    MUIDataTable: {
      styleOverrides: {
        root: {
          height: "100%",
          background: "#e6edec !important"
        },
        tableRoot: {
          minHeight: '239px !important',
        },
        responsiveScroll: {
          minHeight: '150px !important',
          maxHeight: '250px !important'
        }
      }
    },
    MuiTable: {
      styleOverrides: {
        root: {
          background: "#CBF0F0"
        }
      }
    },
    MUIDataTableHeadCell: {
      styleOverrides: {
        root: {
          backgroundColor: "#e6edec !important",
          height: "50px !important"
        }
      }
    },
    MuiTableCell: {
      styleOverrides: {
        footer: {
          padding: '0px 24px 0px 24px !important',
          backgroundColor: "#e6edec !important",
        }
      }
    }
  }
};

export const ModelJson = {
  global: {},
  borders: [],
  layout: {
    type: "row",
    weight: 100,
    children: [
      {
        type: "row",
        weight: 30,
        selected: 0,
        children: [
          {
            type: "tabset",
            weight: 45,
            selected: 0,
            enableDeleteWhenEmpty: false,
            children: [
              {
                type: "tab",
                name: "Structurer les classes sémantiques",
                component: "SemanticTree",
                enableClose: false
              }
            ]
          },
          {
            type: "tabset",
            weight: 55,
            selected: 0,
            children: [
              {
                type: "tab",
                name: "Voir le terme",
                component: "TermDetails",
                enableClose: false
              }
            ]
          }
        ]
      },
      {
        type: "row",
        weight: 70,
        selected: 0,
        children: [
          {
            type: "tabset",
            id: "rightTabs",
            weight: 65,
            selected: 0,
            enableDeleteWhenEmpty: false,
            children: [
              {
                type: "tab",
                name: "Tableau de bord des termes",
                component: "TermListTable",
                enableClose: false
              }
            ]
          },
          {
            type: "tabset",
            weight: 35,
            selected: 0,
            children: [
              {
                type: "tab",
                name: "Voir le terme dans son contexte",
                component: "TermDocsTable",
                enableClose: false
              }
            ]
          }
        ]
      },
    ]
  }
};